<script lang="ts">
    import { trans } from '$assets/shop-translator.js';

    export let searchUrl: string;
</script>

<div
    class="border-content-brand my-m flex justify-between border border-solid bg-commercial-neutral p-m text-content-brand"
>
    <div class="flex items-center gap-xs">
        <span>{trans('tour.dates.sale.closed')}</span>
    </div>
    <a href={searchUrl} class="flex items-center gap-xs underline">
        {trans('tour.dates.sale.see_travels')}
    </a>
</div>
